import React, { Component } from 'react';
import axios from 'axios';
import ImageUploader from 'react-images-upload';
import Swal from "sweetalert2/dist/sweetalert2";

import MenuList from '../Menu';
import InputRows from './InputRows';
import PortfolioImages from './PortfolioImages';
import MyImgs from './MyImgs';
import SinglePortfolio from './Port';
import Helpers from "../../../libs/helpers";

import { language, menu, swalText, infoText, langs } from "../../../Constants";

import './portfolio.scss';

export default class Portfolio extends Component {
    constructor(props){
        super(props);
        this.state = {
            portfolios: [],
            initialized: false,
            pictures: [],
            temporaryImages: [],
        };
    }

    componentDidMount() {
        axios.post('/api/check').then(result => {
            if (result.data.message !== 'you Were authorized') {
                this.props.history.push('/admin');
            }
            axios.post('/api/portfolio/getAll').then(({ data }) => {
                let { result: portfolios } = data;
                this.setState({
                    portfolios,
                    initialized: true,
                });
                document.title = menu[2].text;
            })
        }).catch(res => {
            if (res) {
                this.props.history.push('/admin');
            }
        })
    }

    onDrop = picture => {
        this.setState({ pictures: picture });
    };

    addPhoto = picture => {
        if (picture.length > 1) picture.shift();
        let formData = new FormData();
        let id = document.querySelector('#myOwnModule').dataset.id;
        formData.append('image', picture[0]);
        formData.append('id', id);
        axios.post('/api/portfolio/addPicture', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }).then(({ data }) => {
            const { message, newImage: image } = data;
            if(message === 'Photo added') {
                let portfolios = this.state.portfolios;
                portfolios.find(el => +el.portfolioId === +id).images.push(image);
                this.setState({ portfolios })
            }
        })
    };

    printImages = images => {
        this.setState({ temporaryImages: images })
    };

    closeModule = e => {
        if (!e.target.closest('#myOwnModule') || e.target.classList.contains('closeModule')) {
            let myModule = document.querySelector('#myOwnModule');
            myModule.classList.remove('openModule');
            myModule.dataset.id = '';
            document.removeEventListener('click', this.closeModule);
            this.setState({
                temporaryImages: [],
            })
        }
    };

    delImg = id => {
        const { pictures } = this.state;
        pictures.splice(id, 1);
        this.setState({ pictures })
    };

    changeMainImg = (id, images) => {
        const { portfolios } = this.state;
        portfolios.find(el => +el.portfolioId === +id).images = images;
        this.setState({ portfolios })
    };

    change = (newData, id, year) => {
        const { portfolios } = this.state;
        portfolios.find(el => el.portfolioId === id).data = newData;
        portfolios.find(el => el.portfolioId === id).year = year;
        this.setState({ portfolios })
    };

    addPortfolio = e => {
        e.preventDefault();
        let tags = document.querySelectorAll('.row > input, .row > textarea'),
            year = document.querySelector('#year').value,
            info = [].map.call(tags, el => el.value.trim()),
            main = document.querySelector('#selectedImages .checked').value,
            errors = Helpers.checkErrors(info);

        if (errors.length) {
            Swal.fire({
                type: 'error',
                title: 'Կիսատ ինֆորմացիա',
                text: 'Լրացրեք բոլոր դաշտերը'
            });
            let tags = document.querySelectorAll('.row > input, .row > textarea');
            return tags.forEach((el, index) => {
                errors.includes(index) ? el.classList.add('error') : el.classList.remove('error');
            });
        }
        else if (!this.state.pictures.length || this.state.main === false) {
            Swal.fire({
                type: 'error',
                title: 'Նկար ընտրված չի',
                text: 'Ընտրեք գոնե մեկ նկար'
            });
            return;
        }

        let formData = new FormData();
        for (let i in infoText)
            if (infoText.hasOwnProperty(i))
                formData.append(infoText[i], info[i]);
        for(let i in this.state.pictures)
            formData.append(`image-${i}`, this.state.pictures[i]);
        formData.append('main', main);
        formData.append('year', year);
        axios.post('/api/portfolio/add', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(({ data }) => {
            const {id, images, info , message } = data;
            if (message !== 'All added norm') {
                Swal.fire({
                    title: 'Ավելացնել չստացվեց',
                    text: 'Խնդրում ենք ձորձեք նորից',
                    type: 'error',
                });
                return;
            }

            let newPortfolio = {
                portfolioId: id,
                year,
                data: [],
                images: [...images],
            };

            langs.map((el, index) => {
                newPortfolio.data.push({
                    language: el,
                    title: info[2 * index],
                    text: info[2 * index + 1],
                })
            });

            let portfolios = this.state.portfolios;
            this.setState({
                portfolios : [...portfolios, newPortfolio],
                pictures: [],
            }, () => {
                [].forEach.call(document.querySelectorAll('input, textarea'), el => { el.value = '' });
                Swal.fire({
                    title: swalText.titleSuccess,
                    confirmButtonText: swalText.ok,
                    type: 'success',
                })
            });
        })
    };

    render() {
        if (!this.state.initialized) return null;
        let inputRow = language.map(lang => <InputRows lang={lang} />);
        return (
            <div id='portfolioPage'>
                <div id='myOwnModule'>
                    <div id="header">
                        <div/>
                        <div>Փոփոխություններ նկարների հետ</div>
                        <div className={'closeModule'} onClick={this.closeModule}>X</div>
                    </div>
                    <div id='main'>
                        {this.state.temporaryImages.map((image, index) => (
                            <PortfolioImages
                                image={image}
                                key={index}
                                id={index}
                                changeMainImg={this.changeMainImg}
                                closeModule={this.closeModule}
                            />
                        ))}
                    </div>
                    <div id='footer'>
                        <ImageUploader
                            withIcon={false}
                            buttonText='Ավելացնել Նկար'
                            onChange={this.addPhoto}
                            label='Առավելագույն չափսը 5mb, թույլատրվում է jpg|gif|png'
                            imgExtension={['.jpg', '.gif', '.png']}
                            maxFileSize={5242880}
                            singleImage={true}
                        />
                    </div>
                </div>
                <MenuList history={this.props.history} />
                <div id='right'>
                    <header><h1>{menu[2].text}</h1></header>
                    <div>
                        <h3><em>Ավելացնել պորտֆոլիո</em></h3>
                        <form onSubmit={this.addPortfolio}>
                            <div id='formRight'>{ inputRow }</div>
                            <div id='yearContainer'>
                                <label htmlFor="year">Տարի</label>
                                <input type="number" id='year' placeholder={2019} />
                            </div>
                            <div id='formImages'>
                                <ImageUploader
                                    withIcon={true}
                                    buttonText='Ընտրեք Նկարներ'
                                    onChange={this.onDrop}
                                    label='Առավելագույն չափսը 5mb, թույլատրվում է jpg|gif|png'
                                    imgExtension={['.jpg', '.gif', '.png']}
                                    maxFileSize={5242880}
                                />
                                <div id='selectedImages'>
                                    {this.state.pictures.map((el, index)=>
                                        <MyImgs src={URL.createObjectURL(el)} key={index} id={index} delImg={this.delImg}/>
                                    )}
                                </div>
                            </div>
                            <div id='formSubmit'><button>Ավելացնել</button></div>
                        </form>
                    </div>
                    <div id='portfolios'>
                        <div><h3><em>Մեր Պորտֆոլիոները</em></h3></div>
                        <div id='portfoliosTags'>
                            {this.state.portfolios.map((el, index) =>
                                <SinglePortfolio
                                    {...el}
                                    key={index}
                                    change={this.change}
                                    closeModule={this.closeModule}
                                    printImages={this.printImages}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
